
        import 'CareResults.e96e839.css-module'
        export default {"Container":"Container_CareResults_e96e839","ResultList":"ResultList_CareResults_e96e839"}
    